export enum ReportTypes {
    MARGIN_REPORT = 'margin-report',
    SALES_PIPELINE = 'sales-pipeline'
}